<template>
    <nut-popup v-model:visible="visible" style="background-color: transparent" @close="closeModal">
        <div class="dialog-content">
            <div class="content-box">
                <div class="title">提示</div>
                <div class="desc" v-if="showType === 'openInwx'">
                    <p>请在微信端打开活动.</p>
                    <p>再领取红包</p>
                </div>
                <div class="desc" v-if="showType === 'mofangAuth'">
                    <p>请先进行微信授权</p>
                    <p>再领取红包</p>
                </div>
                <div class="desc" v-if="showType === 'copyLink'">
                    <p>本活动需在【微信】中打开</p>
                    <p>请复制链接，前往微信参与</p>
                </div>
                <div class="desc" v-if="showType === 'togetherCopyLink'">
                    <p>需在【微信】中分享同享奖励</p>
                    <p>请复制链接，前往微信分享</p>
                </div>
                <TxButton src="anniu_2" :name="`复制活动链接-${typeLableMap.get(showType)}`" class="t-btn" @click="handleCopy" v-if="['openInwx', 'copyLink', 'togetherCopyLink'].includes(showType)">
                    复制活动链接
                </TxButton>
                <TxButton src="anniu_2" name="积木授权" class="t-btn" @click="handleMofangAuth" v-if="showType === 'mofangAuth'">
                    前往授权
                </TxButton>
            </div>
            <div class="close-box" @click="closeModal">
                <TxButton src="gb" name="关闭通用提示弹窗">
                </TxButton>
            </div>
        </div>
    </nut-popup>
</template>

<script lang="ts" setup>
import { ref, inject, computed } from 'vue';
const { copy_link } = inject('GlobalData');
import eventEmitter from '@utils/event';
import { useClipboard } from '@vueuse/core';
const { copy, isSupported } = useClipboard();

eventEmitter.on('showCommomTipModal', (type: string) => {
    showType.value = type
    visible.value = true
});

const visible = ref(false)
const showType = ref('')

const typeLableMap = new Map([
    ['openInwx', '领取红包'],
    ['copyLink', '参与活动'],
    ['togetherCopyLink', '同享奖励'],
])

const copyContent = computed(() => {
    return `链接：${copy_link.value}\n点击此链接，一起参与活动吧`
})

async function handleCopy() {
    if (isSupported) {
        await copy(copyContent.value);
        eventEmitter.emit('toast', {
            text: '复制成功',
        });
    } else {
        eventEmitter.emit('toast', {
            text: '您的设备不支持复制',
        });
    }
}

function handleMofangAuth() {
    eventEmitter.emit('mofangAuthBus');
}

function closeModal() {
    visible.value = false
}

</script>

<style lang="scss" scoped>
.dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 24px;

    .content-box {
        @include bg('db_9');
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding-top: 60px;
        padding-bottom: 120px;

        .title {
            font-size: 40px;
            color: #fff;
        }

        .desc {
            @include bg('tczidb');
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #202631;
        }
    }

    .close-box {
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        .close-icon {
            color: #fff;
        }
    }
}
</style>